<template>
  <div>
    <div class="q-pt-none">
      <q-form ref="adicionarPerguntaForm" @submit.prevent>
        <div class="row col-12 q-gutter-x-sm text-brand-5 text-weight-bold">
          <div class="col-md-4 col-sm-11 col-xs-11">
            <div class="q-ml-sm titulo-input">Pergunta Atividade</div>
            <q-input
              dense
              outlined
              v-model="adicionarPerguntaDto.pergunta"
              :rules="[(val) => (val && val.length > 0) || 'Campo Obrigatório']"
            />
          </div>
          <div>
            <q-btn
              class="q-mt-sm btn-adicionar"
              color="primary"
              label="Adicionar Pergunta"
              dense
              no-caps
              icon="add_circle_outline"
              @click.prevent="adicionarPergunta()"
            />
          </div>
        </div>
      </q-form>
    </div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";

export default {
  props: ["unidadeId", "atividadeId"],
  emits: ["closing"],
  setup(props, { emit }) {
    const adicionarPerguntaForm = ref(null);
    const adicionarPerguntaDto = ref({
      pergunta: "",
    });
    const store = useStore();
    const quasar = useQuasar();

    const adicionarPergunta = async () => {
      try {
        const valido = await adicionarPerguntaForm.value.validate();
        if (!valido) {
          return;
        }

        await store.dispatch("pdt/adicionarPergunta", {
          unidadeId: props.unidadeId,
          atividadeId: props.atividadeId,
          pergunta: adicionarPerguntaDto.value.pergunta,
        });

        resetForm();
        emit("closing");
        quasar.notify({
          message: "Pergunta adicionada",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      } catch (error) {
        let message = "Ocorreu um erro ao adicionar a pergunta";
        if (error.response) {
          message = error.response.data.erros;
        }

        quasar.notify({
          message,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
            },
          ],
        });
      }
    };

    const resetForm = () => {
      adicionarPerguntaDto.value.pergunta = "";
      adicionarPerguntaForm.value.reset();
    };

    return {
      adicionarPerguntaForm,
      adicionarPerguntaDto,
      adicionarPergunta,
    };
  },
};
</script>

<style scoped>
.btn-adicionar {
  margin: 25px 0px 0px 0px;
}
@media (max-width: 600px) {
  .titulo-input {
    margin: 0px;
    font-size: 12px;
  }
  .btn-adicionar {
    margin: 5px 0px 0px 0px;
    font-size: 13px;
  }
}
</style>
